import {
  Box,
  Divider,
  Flex,
  Text,
  Modal,
  ModalOverlay,
  Heading,
  useDisclosure,
  Select,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { FiMail, FiPhoneCall } from "react-icons/fi";
import AddOrderAddress from "./AddOrderAddress";
import CustomerAdd from "./CustomerAdd";
import BillingAddress from "./BillingAddress";
import ShippingAddress from "./ShippingAddress";
import OrderTags from "./OrderTags";
import { useEffect } from "react";
import axios from 'axios'
import { Auth } from './Auth';
import { useToast } from '@chakra-ui/react'

const RightSidebar = ({
  customerName,
  customerGmail,
  customerPhone,
  shippingArea,
  shippingCity,
  billingAddress,
  title,
  title2,
  renderSummary,
  addressId,
  partyId,
  addressChangeRender,
  orderData,
  party,
}) => {
  const [addressModalName, setAddressModalName] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedPartyType, setSelectedPartyType] = useState("");
  const partyDtails = party?.PartyDetail[0];
  console.log(party)
  const toast = useToast()
  useEffect(() => {
    if (partyDtails?.isFounder) {
      setSelectedPartyType("founder");
    }
    if (partyDtails?.isIndividual) {
      setSelectedPartyType("individual");
    }
  }, [partyDtails]);

  const handlePartyChange = async (e) => {
    setSelectedPartyType(e.target.value);

    let data = JSON.stringify({
      "partyId": party.id, 
      "customerType": `${e.target.value}`,
    });
    
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/party/party-details/update-customer-type`, 
      headers: {
        'Content-Type': 'application/json',
        'Authorization': Auth()
      },
      data : data
    };

    axios.request(config)
    .then((response) => {
      toast({
        title: `Customer Type Updated`,
        position: 'top',
        status: 'success',
        duration: 4000,
        isClosable: true,
      })
      // console.log(JSON.stringify(response.data));
    })
    .catch((error) => {
      toast({
        title: `Something went wrong please try again`,
        position: 'top',
        status: 'error',
        duration: 4000,
        isClosable: true,
      })
      console.log(error);
    });

    console.log(e.target.value, "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx");
  };

  return (
    <Box
      mt={
        title === "Order Summary" || title === "Order" || title === "Return"
          ? ""
          : { base: "0px", md: "0px", lg: "90px", xl: "90px", "2xl": "90px" }
      }
    >
      <Box
        shadow={"md"}
        rounded={"md"}
        border={"1px"}
        borderColor={"gray.200"}
        bgColor={"rgba(255, 255, 255, 1)"}
        p={3}
        mb={3}
      >
        <Heading size={"md"}>Customer Type</Heading>
        <Divider size={1} my={2} borderBottomColor={"black"} />
        <Select
          name="Customer Type"
          placeholder="Select type"
          onChange={handlePartyChange}
          value={selectedPartyType}
        >
          <option value="founder">Founder</option>
          <option value="individual">Individual</option>
        </Select>
      </Box>

      {/* Cutomer Add  & select Field */}

      {title === "Order Summary" && (
        <>
          <CustomerAdd renderSummary2={renderSummary} />

          <AddOrderAddress />
        </>
      )}

      {title !== "Order Summary" && (
        <>
          {/* Customer Details */}
          <Box
            shadow={"md"}
            rounded={"md"}
            border={"1px"}
            borderColor={"gray.200"}
            bgColor={"rgba(255, 255, 255, 1)"}
            p={4}
          >
            <Heading size={"md"}>Customer Details</Heading>
            <Divider size={1} my={2} borderBottomColor={"black"} />
            <Text fontWeight={"medium"}>{customerName}</Text>
            <Flex my={1} alignItems={"center"}>
              <FiMail />
              <Text ml={2}>{customerGmail}</Text>
            </Flex>
            <Flex my={1} alignItems={"center"}>
              <FiPhoneCall />
              <Text ml={2}>{customerPhone}</Text>
            </Flex>
          </Box>
          {/* Address */}
          <Box
            shadow={"md"}
            rounded={"md"}
            border={"1px"}
            borderColor={"gray.200"}
            p={4}
            my={5}
            bgColor={"rgba(255, 255, 255, 1)"}
          >
            <Box>
              <Flex justifyContent={"space-between"}>
                <Heading size={"md"}>Shipping Address</Heading>
                {title2 === "Order Main" && (
                  <Text
                    textDecoration={"underline"}
                    color={"blue.500"}
                    cursor={"pointer"}
                    onClick={() => {
                      setAddressModalName("shipping");
                      onOpen();
                    }}
                  >
                    Edit
                  </Text>
                )}
              </Flex>
              <Divider size={1} my={2} borderBottomColor={"black"} />
              <Box>
                <Text fontSize={"sm"} fontWeight={"medium"}>
                  Address Line 1 :- {shippingArea?.addressline1 || "----"}
                </Text>
                <Text fontSize={"sm"} fontWeight={"medium"}>
                  Address Line 2 :- {shippingArea?.addressline2 || "----"}
                </Text>
                <Text fontSize={"sm"} fontWeight={"medium"}>
                  City :- {shippingArea?.city || "----"}
                </Text>
                <Text fontSize={"sm"} fontWeight={"medium"}>
                  State :- {shippingArea?.state || "----"}
                </Text>
                <Text fontSize={"sm"} fontWeight={"medium"}>
                  District :- {shippingArea?.district || "----"}
                </Text>
                <Text fontSize={"sm"} fontWeight={"medium"}>
                  Country :- {shippingArea?.country || "----"}
                </Text>
                <Text fontSize={"sm"} fontWeight={"medium"}>
                  Pin Code :- {shippingArea?.pincode || "----"}
                </Text>
              </Box>
            </Box>
            <Box mt={5} bgColor={"rgba(255, 255, 255, 1)"}>
              <Flex justifyContent={"space-between"}>
                <Heading size={"md"}>Billing Address</Heading>
                {title2 === "Order Main" && (
                  <Text
                    textDecoration={"underline"}
                    color={"blue.500"}
                    cursor={"pointer"}
                    onClick={() => {
                      setAddressModalName("billing");
                      onOpen();
                    }}
                  >
                    Edit
                  </Text>
                )}
              </Flex>
              <Divider size={1} my={2} borderBottomColor={"black"} />
              <Box>
                <Text fontSize={"sm"} fontWeight={"medium"}>
                  Address Line 1 :- {billingAddress?.addressline1 || "----"}
                </Text>
                <Text fontSize={"sm"} fontWeight={"medium"}>
                  Address Line 2 :- {billingAddress?.addressline2 || "----"}
                </Text>
                <Text fontSize={"sm"} fontWeight={"medium"}>
                  City :- {billingAddress?.city || "----"}
                </Text>
                <Text fontSize={"sm"} fontWeight={"medium"}>
                  State :- {billingAddress?.state || "----"}
                </Text>
                <Text fontSize={"sm"} fontWeight={"medium"}>
                  District :- {billingAddress?.district || "----"}
                </Text>
                <Text fontSize={"sm"} fontWeight={"medium"}>
                  Country :- {billingAddress?.country || "----"}
                </Text>
                <Text fontSize={"sm"} fontWeight={"medium"}>
                  Pin Code :- {billingAddress?.pincode || "----"}
                </Text>
              </Box>
            </Box>
          </Box>
        </>
      )}
      {/* ## TAGS ## */}
      <Box
        shadow={"md"}
        rounded={"md"}
        border={"1px"}
        borderColor={"gray.200"}
        p={4}
        my={5}
        bgColor={"rgba(255, 255, 255, 1)"}
      >
        <Heading size={"md"}>Tags</Heading>
        <Divider size={1} my={2} borderBottomColor={"black"} />
        <OrderTags isTitle={true} />
      </Box>
      {/* Notes */}
      <Box
        shadow={"md"}
        rounded={"md"}
        border={"1px"}
        borderColor={"gray.200"}
        p={4}
        my={5}
        bgColor={"rgba(255, 255, 255, 1)"}
      >
        <Heading size={"md"}>Notes</Heading>
        <Divider size={1} my={2} borderBottomColor={"black"} />
        <Text my={5}>No notes from customer</Text>
      </Box>

      {/* Edit Shipping & Billing Address Modal */}
      <Modal isOpen={isOpen} onClose={onClose} size={"6xl"}>
        <ModalOverlay />
        {addressModalName === "shipping" && (
          <ShippingAddress
            onClose={onClose}
            shippingArea={shippingArea}
            partyId={partyId}
            shippingId={addressId.shippingId}
            addressChangeRender={addressChangeRender}
            orderData={orderData}
          />
        )}
        {addressModalName === "billing" && (
          <BillingAddress
            onClose={onClose}
            billingAddress={billingAddress}
            partyId={partyId}
            billingId={addressId.billingId}
            addressChangeRender={addressChangeRender}
            orderData={orderData}
          />
        )}
      </Modal>
    </Box>
  );
};

export default RightSidebar;
